export default __webpack_public_path__ + "static/media/single-right-border-both.8c576170.svg";